import { render, staticRenderFns } from "./CompetitionDetailEntry.vue?vue&type=template&id=a5b4df66&scoped=true&"
import script from "./CompetitionDetailEntry.vue?vue&type=script&lang=js&"
export * from "./CompetitionDetailEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b4df66",
  null
  
)

export default component.exports